import { Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import * as fromRoot from '@core/redux/index';
import * as PopupAction from '@core/redux/popup/popup.actions';
import * as ProjectAction from '@core/redux/project/project.actions';
import { Store } from '@ngrx/store';
import { NgClickOutsideDelayOutsideDirective, NgClickOutsideExcludeDirective } from 'ng-click-outside2';

@Component({
  selector: 'app-project-menu',
  templateUrl: './project-menu.component.html',
  styleUrls: ['./project-menu.component.less'],
  standalone: true,
  imports: [NgClickOutsideExcludeDirective, NgClickOutsideDelayOutsideDirective],
})
export class ProjectMenuComponent {
  private readonly store = inject(Store<fromRoot.State>);

  protected readonly model = toSignal(this.store.select(fromRoot.getProjectSelectedEntity));

  protected readonly statusDeleteConfirm = signal(0);

  onClose(): void {
    this.store.dispatch(new PopupAction.CloseProjectMenu());
    this.store.dispatch(new ProjectAction.SelectUpdateAction(null));
  }

  onDelete(): void {
    this.statusDeleteConfirm.update(count => count + 1);

    if (this.statusDeleteConfirm() === 2) {
      const currentModel = this.model();
      if (currentModel) {
        this.store.dispatch(new ProjectAction.DeleteAction(currentModel));
        this.onClose();
      }
    }
  }

  onRestore(): void {
    const currentModel = this.model();
    if (currentModel) {
      this.store.dispatch(new ProjectAction.RestoreAction(currentModel));
      this.onClose();
    }
  }

  onOpenEditForm(event) {
    this.store.dispatch(new ProjectAction.SelectUpdateAction(this.model().id));
    this.openForm(event);
  }

  onOpenCreateSubProjectForm(event) {
    this.store.dispatch(new ProjectAction.SetParentId(this.model().id));
    this.openForm(event);
  }

  openForm(event) {
    let position = 0;
    const popupHeight = 295;
    const halfPopupHeight = popupHeight / 2;
    const screenHeight = window.innerHeight;
    const topHeight = event.pageY;
    const bottomHeight = screenHeight - topHeight;

    if (halfPopupHeight <= topHeight && halfPopupHeight <= bottomHeight) {
      position = topHeight - halfPopupHeight;
    } else if (halfPopupHeight > topHeight) {
      position = 15;
    } else if (halfPopupHeight > bottomHeight) {
      position = screenHeight - popupHeight - 15;
    }
    this.store.dispatch(new PopupAction.OpenProjectFormMenu(position, 440));
  }
}
